import timezones, { TimeZone } from 'timezones-list';

const TIME_ZONES_BLACKLIST = new Set(['Europe/Zaporizhzhia', 'Europe/Simferopol']);
const formattedTimeZones = timezones.filter((timeZone: TimeZone) => !TIME_ZONES_BLACKLIST.has(timeZone.tzCode));

export default formattedTimeZones;
